import { PATH_APP } from "../paths";
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import AuthProtect from "src/components/Auth/AuthProtect";
import Roles from "src/utils/Roles";
import TpvCartaLayout from "src/layouts/TpvCartaLayout";

// ----------------------------------------------------------------------

const TpvCartaRoutes = {
  path: PATH_APP.tpv.root,
  guard: AuthProtect,
  layout: TpvCartaLayout,
  routes: [
    // tpv
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.pago,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaCamarero/payment/Pago")
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.productCamarero,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaCamarero/product")
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.cartaCamarero,
      component: lazy(() =>
        import(
          "src/views/app/UserNormal/cartaCamarero/tuCartaCamarero/DarkKitchen"
        )
      ),
    },
    {
      exact: true,
      path: PATH_APP.tpv.checkoutCamarero,
      component: lazy(() =>
        import(
          "src/views/app/UserNormal/cartaCamarero/tuCartaCamarero/DarkKitchen/TpvPayment"
        )
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.paymentCamarero,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaCamarero/payment")
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.invoiceCamarero,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaCamarero/invoice")
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.invoiceCamarero,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaCamarero/invoice")
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.factura,
      component: lazy(() =>
        import("src/components/functionality/Factura/userNormal")
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.pedidos,
      component: lazy(() =>
        import("src/components/functionality/Pedidos/userNormal")
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.facturaAdd,
      component: lazy(() =>
        import("src/components/functionality/Factura/userNormal/FacturaAdd")
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.facturaEdit,
      component: lazy(() =>
        import("src/components/functionality/Factura/userNormal/FacturaAdd")
      ),
    },
    {
      exact: true,
      path: PATH_APP.tpv.productoComplemento,
      component: lazy(() =>
        import("src/views/app/UserNormal/cartaCamarero/product")
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.tickets,
      component: lazy(() => import("src/views/app/UserNormal/tickets/index")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.display,
      component: lazy(() =>
        import("src/views/app/UserNormal/displays/displayFunctionality")
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL],
      path: PATH_APP.tpv.root,
      // 2026-09-29 · Antes redirigía a `PATH_APP.tpv.tpv`, que no existe →
      // generatePath(undefined) = "/" → GuestProtect (+GET readAdmin) →
      // /app/tucarta → /app/tucarta/tpv: 3 redirecciones tras cada
      // comandar/cobrar. Ahora va directo al plano de mesas.
      component: () => <Redirect to={PATH_APP.tuCarta.tpv} />,
    },
    {
      component: () => <Redirect to="/404" />,
    },
  ],
};

export default TpvCartaRoutes;
